export enum EmployeeConsiderationPayer {
    No = 0,
    PaidByBuyer = 1,
    PaidBySeller = 2,
    PaidByBoth = 3,
}

export const EmployeeConsiderationPayers = [
    { id: EmployeeConsiderationPayer.No, name: 'No' },
    { id: EmployeeConsiderationPayer.PaidByBuyer, name: 'Yes - Paid by Buyer' },
    { id: EmployeeConsiderationPayer.PaidBySeller, name: 'Yes - Paid by Seller' },
    { id: EmployeeConsiderationPayer.PaidByBoth, name: 'Yes - Paid by Both' },
];
